import { render, staticRenderFns } from "./ProjectUpdateForm.vue?vue&type=template&id=27d1e0fa&scoped=true"
import script from "./ProjectUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProjectUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectUpdateForm.vue?vue&type=style&index=0&id=27d1e0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1e0fa",
  null
  
)

export default component.exports